import React, { useEffect, useState } from "react";
import { Col, Container, Row } from "react-bootstrap";

import HeroContent from "../../component/hero/HeroContent";
import HeadingH1 from "../../shared_lib/custom/headings/headingH1/HeadingH1";
import CardContent from "../../component/card/CardContent";
import { useTranslation } from "react-i18next";
import { AppModel } from "../../models/appModel";
import { getListApps } from "../../services/landing.service";
import { setErrorTypeAction } from "../../../redux/errors/errorsActions";
import { useDispatch } from "react-redux";

export function HomePage() {
  const { t } = useTranslation();
  const dispatch = useDispatch();

  const [listApps, setListApps] = useState<AppModel[]>([]);
  useEffect(() => {
    getListApps().then(
      (res) => setListApps(res),
      (err) => dispatch(setErrorTypeAction(t("error.loadApp")))
    );
  }, []);

  const goToAppLink = (url: string) => {
    window.open(url);
  };

  return (
    <>
      <HeroContent />
      <Container>
       {/* <Row className={"mt-5 pt-5"}>
          <Col xs="12">
            <HeadingH1>Lorem ipsum dolor</HeadingH1>
          </Col>
        </Row>*/}
        <Row className={"mt-5"}>
          {listApps &&
            listApps.length > 0 &&
            listApps.map((app, i) => (
              <Col xs="12" md="6" lg="3" key={i}>
                <CardContent data={app} goToLinkHandler={goToAppLink} />
              </Col>
            ))}
          {(!listApps || listApps.length <= 0) && (
            <Col xs="12">
              <div>{t("msg.emptyApp")}</div>
            </Col>
          )}
        </Row>
      </Container>
    </>
  );
}
